/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import type { IClient } from "@/services/model/client";

interface WhatsAppFloatButtonProps {
  enabled?: boolean;
  client?: IClient | null;
  /** Extra pixels to raise the button from the bottom. Default 96. */
  bottomOffset?: number;
}

const WhatsAppFloatButton: React.FC<WhatsAppFloatButtonProps> = ({
  enabled = true,
  client: clientProp = null,
  bottomOffset = 50,
}) => {
  const [client, setClient] = useState<IClient | null>(clientProp);

  useEffect(() => {
    setClient(clientProp);
  }, [clientProp]);

  if (!enabled || !client?.whatsAppNumber) return null;

  const href = `https://api.whatsapp.com/send?phone=${client.whatsAppNumber}`;

  return (
    <div>
      <a
        href={href}
        className="float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
        style={{
          // keep it fixed and safely above the Snackbar
          position: "fixed",
          right: "max(10px, env(safe-area-inset-right))",
          bottom: `max(${bottomOffset}px, calc(env(safe-area-inset-bottom) + 5px))`,
          zIndex: 1700, // above Snackbar but below full-screen modals
        }}
      >
        <WhatsAppIcon fontSize="large" className="my-float" />
      </a>
    </div>
  );
};

export default WhatsAppFloatButton;
